"use strict";

/**
 * @ngdoc factory
 * @name diceApp.factory:FeedbackModal
 * @description
 * Opens a modal to create/edit feedback.
 */
angular
  .module("diceApp")
  .factory("FeedbackModal", function (Feedback, $uibModal, message, $filter) {
    function open({ feedback, evaluationId, participantId, onChange }) {
      $uibModal.open({
        templateUrl: "es6/report/feedback.modal.html",
        controllerAs: "feedbackModalController",
        controller: function ($uibModalInstance) {
          const feedbackModalController = this;
          feedbackModalController.feedback = angular.copy(feedback);

          feedbackModalController.close = function () {
            $uibModalInstance.close();
          };

          feedbackModalController.stripFormat = function ($html) {
            return $filter("htmlToPlaintext")($html);
          };

          feedbackModalController.save = function () {
            // General feedback (no role) is shared by the whole evaluation, only
            // role specific feedback is stored on the filtered participant.
            const role = _.get(feedbackModalController.feedback, "role.id");

            let entity = { type: "evaluation", id: evaluationId };
            if (role && participantId) {
              entity = { type: "participant", id: participantId };
            }

            const body = {
              message: feedbackModalController.feedback.message,
              entity
            };

            Feedback.saveOrUpdate({ evaluationId, role }, body).$promise.then(
              () => {
                feedbackModalController.close();
                message.addSuccessLabel("Message.Save.Success");
                onChange();
              }
            );
          };
        }
      });
    }

    return { open };
  });
